import classnames from 'classnames';
import React from 'react';

import css from 'reactComponents/icons/defaultIconStyles.css';

export default function IconUsers({ className, ...rest }) {
    return (
        <svg
            height="16"
            width="16"
            xmlns="http://www.w3.org/2000/svg"
            className={classnames(css.main, className)}
            {...rest}
        >
            <path
                className={css.colored}
                d="M10.502 8.788v.001c.257.253.752.644 1.67 1.114 1.633.835 2.348 1.477 2.348 2.53 0 .995-1.332 1.909-3.449 2.342-.757.155-1.127.175-2.058.188h-.004c-.929-.013-1.28-.033-2.037-.188-2.115-.433-3.452-1.347-3.452-2.342 0-1.053.715-1.695 2.348-2.53.897-.459 1.39-.843 1.652-1.097l.003-.002c.113-.109.113-.194.113-.194s-.004-.152-.004-.253a.214.214 0 0 0-.112-.196V8.16c-.487-.342-.875-.902-1.118-1.744-.164-.571-.306-1.225-.306-1.926 0-2.154 1.317-3.453 2.941-3.453 1.623 0 2.941 1.299 2.941 3.453a6.89 6.89 0 0 1-.331 2.037c-.254.826-.651 1.362-1.145 1.681 0 0-.1.05-.1.183l.001.22s-.008.076.099.177zM3.356 7.63c-.384-.269-.688-.71-.879-1.372-.13-.449-.242-.964-.242-1.515 0-1.695 1.037-2.717 2.314-2.717.193 0 .559.023.8.103-.486.541-.792 1.424-.8 2.641 0 2.022 1.153 2.904 1.153 3.245 0 .55-.146.381-2.035 1.668-1.794 1.223-1.873 2.126-1.899 2.818C.788 12.119 0 11.573 0 10.992c0-.829.771-1.334 2.056-1.991.706-.36 1.094-.663 1.3-.862l.003-.003c.112-.108.113-.194.113-.194v-.119a.209.209 0 0 0-.116-.192V7.63z"
            />
        </svg>
    );
}
